import { forwardRef } from 'react'
import classNames from 'classnames'
import { Icon } from './Icon'
import { Button } from './Button'
import { ButtonProps } from './Button'

const CloseButton = forwardRef<HTMLButtonElement, ButtonProps>(({
    className,
    ...otherProps
}, ref) => {

    const _className = classNames(
        'btn btn-ghost-gray200 btn-close',
        className
    )

    return (
        <button
            ref={ref}
            title="Close"
            aria-label="Close"
            className={_className}
            {...otherProps}
        />
    )
})

export { CloseButton }
